/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.


  // Sitewide synthetic sale: recompute strike + sale price when variant changes.
  // ----------------------------------------------------------------------------
  // The theme's primary variant-change flow uses the Section Rendering API
  // (see changeVariant() in theme.js → $sectionApi.navigate) which re-fetches
  // the section HTML and morphs it in place, so product-price.liquid is re-rendered
  // server-side and the data-base-price / data-sale-pct attributes update for
  // free. This listener is a belt-and-braces resync for any path that fires
  // theme:variant:change without a section morph (e.g. third-party scripts).
  // No-op when settings.sale_active is off (data-synthetic-sale will be absent).
  function syncSyntheticSalePrice(variant, container) {
    if (!variant || typeof variant.price !== 'number') return;
    var scope = (container && container.querySelector) ? container : document;
    var wrappers = scope.querySelectorAll('[data-price-wrapper][data-synthetic-sale]');
    if (!wrappers.length) return;

    var formatMoney = (window.themeVendor && window.themeVendor.themeCurrency)
      ? window.themeVendor.themeCurrency.formatMoney
      : null;
    var moneyFormat = (window.theme && window.theme.moneyFormat) ? window.theme.moneyFormat : '${{amount}}';
    var withCurrencyCode = !!(window.theme && window.theme.settings && window.theme.settings.currency_code_enable);
    var currencyCode = (window.theme && window.theme.currencyCode) ? window.theme.currencyCode : '';

    function money(cents) {
      if (!formatMoney) return cents;
      var s = formatMoney(cents, moneyFormat);
      return withCurrencyCode && currencyCode ? s + ' ' + currencyCode : s;
    }

    wrappers.forEach(function(wrapper) {
      var pct = parseFloat(wrapper.getAttribute('data-sale-pct'));
      if (!(pct > 0)) return;

      // Skip if the new variant has a real compare_at_price > price (e.g. bundles)
      if (variant.compare_at_price && variant.compare_at_price > variant.price) return;

      var basePrice = variant.price;
      // Match Liquid math: price | times: (100 - pct) | divided_by: 100 (integer division)
      var salePrice = Math.floor(basePrice * (100 - pct) / 100);

      wrapper.setAttribute('data-base-price', basePrice);

      var priceEl = wrapper.querySelector('[data-product-price]');
      if (priceEl) {
        priceEl.classList.add('product__price--sale');
        priceEl.textContent = money(salePrice);
      }

      var compareEl = wrapper.querySelector('[data-compare-price]');
      if (compareEl) {
        compareEl.textContent = money(basePrice);
      }
    });
  }

  document.addEventListener('theme:variant:change', function(event) {
    // You might use something like this to write a pre-order feature or a
    // custom swatch feature.
    var variant = event.detail.variant;
    var container = event.target;

    syncSyntheticSalePrice(variant, container);

    if (variant) {
      // console.log('Container ———————— ↓');
      // console.log(container);
      // console.log('Variant —————————— ↓');
      // console.log(variant);
      // ... update some element on the page

      if (variant.available === true) {
        if (null !== document.querySelector('.btn.klaviyo-bis-trigger')) {
          document.querySelector('.btn.klaviyo-bis-trigger').style.display = 'none';
        }
      } else {
        if (null !== document.querySelector('.btn.klaviyo-bis-trigger')) {
          document.querySelector('.btn.klaviyo-bis-trigger').style.display = 'inline-block';
        }
      }

      // cb product siblings
      if ($('.cb-product__block__siblings').length > 0) {
        $('.cb-siblings-metadata.cross-sib').each(function (idx, json_el) {
          let sib_combinations_json = JSON.parse($(json_el).text());
          for (let idx = 0; idx < sib_combinations_json.length; idx++) {
            if (sib_combinations_json[idx].option1 === variant.option1 && sib_combinations_json[idx].option2 === variant.option2) {
              let currSibLinkEl = $('.cb-product__block__siblings a[data-sib_prd_id="' + sib_combinations_json[idx].product_id + '"]');
              if (currSibLinkEl.length > 0) {
                let currSibLinkHref = $(currSibLinkEl).attr('href');
                currSibLinkHref = currSibLinkHref.split('?')[0];
                $(currSibLinkEl).attr('href', currSibLinkHref + '?variant=' + sib_combinations_json[idx].id);
                break;
              }
            }
          }
        });
      }
    }
  });

  document.addEventListener('theme:cart:change', function(event) {
    var cart = event.detail.cart;
    if (cart) {
      // console.log('Cart ———————————— ↓');
      // console.log(cart);
      // ... update an app or a custom shipping caluclator
    }
  });
  // Fired when page loads to update header values
  document.addEventListener('theme:cart:init', (e) => {
    // console.log('theme:cart:init');
    // console.log(e);
  });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  // document.addEventListener('theme:scroll', e => { console.log(e); });
  // document.addEventListener('theme:scroll:up', e => { console.log(e); });
  // document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // Debounced resize listener to bundle changes that trigger document reflow
  // document.addEventListener('theme:resize', e => { console.log(e); });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the 
  // scroll locking code knows what element should maintain scoll. 
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.

  $(function () {
    $('form .product-personalizer').attr('data-morph-skip', '');
  });
})();
